import React, {Component} from 'react';

import strings from 'strings';

import {no_numbers, nn_numbers} from './assets';
import listen from 'assets/listen.png';

import './styles.scss';

class Test extends Component {
	constructor(props) {
		super(props);

		switch (strings.getLanguage()) {
			case 'nn':
				this.assets = nn_numbers;
				break;
			case 'no':
			default:
				this.assets = no_numbers;
				break;
		}
	}

	componentWillReceiveProps(newProps) {
		if (newProps.currentStep !== this.props.currentStep) {
			this.startNewTask(newProps.currentStep);
		}
	}

	componentDidMount() {
		if (this.button) this.button.click();
		this.initializeAudio();
	}
	componentWillUnmount() {
		this.stopSounds();
		clearTimeout(this.timeout);
	}

	initializeAudio = () => {
		Object.values(this.assets).forEach((audioEl) => audioEl.load());

		this.timeout = setTimeout(
			() => this.startNewTask(this.props.currentStep),
			1000
		);
	};

	startNewTask = (taskNumber) => {
		this.stopSounds();
		this.playNumbers(taskNumber);
	};

	playNumbers = (sound) => {
		this.assets[sound].play();
	};

	stopSounds = () => {
		for (const sound of Object.values(this.assets)) {
			sound.pause();
		}
	};

	render() {
		return (
			<div className="WorkingMemory">
				<img className="listen-image" src={listen} alt="" />
				<p>{strings.wsn_test1}</p>
			</div>
		);
	}
}

export default Test;
